import { FamilyApplicationResp, Student } from '@/apis/family_application/requests'

export function isV1RenewalStudent(student: Student) {
  return (
    student.inception_status === 'Renewal Student' &&
    student.is_external_student
  )
}

export function isV1RenewalApplication(application: FamilyApplicationResp) {
  return application.students.some(isV1RenewalStudent)
}


// Hotfix 2025-03-18 
// ACE Only wants us to display the priority group if the student has priority 1 
export function shouldDisplayPriorityGroup(student: Student) { 
  return student.priority_group === 1
}